import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-6 flex flex-col space-y-6" }

import {
  computed, ref,
} from 'vue';
import {
  IMilestone, IStep, ITimeline, ReqHomesDocument,
} from '@/models';
import { MyTimeLineStatus } from '@/constants';
import store from '@/store';
import HomeProgress from '@/components/HomeProgress.vue';
import PreferredLender from '@/components/PreferredLender.vue';
import CheckList from '@/views/timeline/components/CheckList.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const selectedHome = computed(() => store.getters.selectedHome as ReqHomesDocument);
const selectedMilestone = ref<IMilestone>({} as IMilestone);
const selectedCheckList = ref<IStep>({} as IStep);

const getTimeline = computed(() => store.getters.getTimeline as ITimeline);

const handleSelectedCheckList = (checkList:IStep) => {
  selectedCheckList.value = checkList;
};

const handleSelectedMilestone = (milestone: IMilestone) => {
  selectedMilestone.value = milestone;
  selectedCheckList.value = selectedMilestone.value.steps && selectedMilestone.value.steps[0];
  if (selectedMilestone.value.status === MyTimeLineStatus.PENDING) {
    selectedMilestone.value.steps.forEach((checkList, idx) => {
      if (idx && (checkList.status !== selectedMilestone.value.steps[idx - 1].status)) {
        selectedCheckList.value = checkList;
      }
    });
  }
};

const homes = ref<any>({
  activeHome: selectedHome.value,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (homes.value.activeHome)
      ? (_openBlock(), _createBlock(HomeProgress, {
          key: 0,
          isTimelinePanel: true,
          onSelectedMilestoneEmit: handleSelectedMilestone
        }))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _createVNode(CheckList, {
        selectedMilestone: selectedMilestone.value,
        selectedCheckList: selectedCheckList.value,
        checklistClickEvent: true,
        onSelectedCheckListEmit: handleSelectedCheckList
      }, null, 8, ["selectedMilestone", "selectedCheckList"])
    ]),
    _createVNode(PreferredLender)
  ]))
}
}

})